import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UtilitiesPage from '.';

const UtilitiesRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<UtilitiesPage />} />
        </Routes>
    );
};

export default UtilitiesRoutes;
